/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState, useRef } from 'react';
import Image from "next/image";
import Link from 'next/link'
import { useRouter } from 'next/router'
import Heading from "../../components/heading";
import Header3 from '../../components/header/header-rslhome'
import Footer3 from '../../components/footer/footer-3'
import DynamicHero from '../../components/Investor/DynamicHero'
import Seo from '../../components/common/Seo'
import { useDispatch, useSelector } from 'react-redux'
import RslSuperAppBanner from '../../components/RslSuperAppBanner'
import FormLabel from '../../components/label'
import GoogleMap from '../../components/subscription/googleMap'
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import ScheduleIcon from "@mui/icons-material/Schedule";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PickupLocation from '../../components/subscription/locationSelection';
import { LocalizationProvider, DesktopTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CtaButton from "../../components/buttonWithArrow";
import CommonAlertDialog from "../../components/Dialog/dialog";
import PhoneInput from "../../components/phoneInput";
import {
    Box,
    Grid,
    Button,
    Modal,
    Typography,
    IconButton,
    Tooltip,
    TextField,
    MenuItem,
    InputAdornment,
    OutlinedInput,
    Stack,
    Card,
    CircularProgress,
    Divider,
    Autocomplete,
    Skeleton,
    FormControl,
    Select,
    FormHelperText,
    Checkbox,
    ListItemText,
    Radio
} from '@mui/material'
import dayjs from "dayjs";
import moment from "moment";
import MapIcon from "@mui/icons-material/Map";
import { getActiveSubscriptionPlans, getCarModels, getFare, validateLocation, createEnquiry } from '../../redux/slices/common'
import { lockScrollNew, unlockScrollNew } from "../../utils/scrollLock";
import { bannerHeight } from "../../utils/bannerHeight";
import { countries } from "../../data/countries";
import { fetchSeoByPage } from '../../lib/seoHelper';

export default function SubscriptionPage({ meta }) {

    const dispatch = useDispatch()

    const router = useRouter()
    const currentPath = router.asPath

    const { activeSubscriptionsData, allCarModelData, tripFare, locationValidationData, createEnquiryRes } = useSelector(state => state.common)


    const [focusNext, setFocusNext] = useState(false)

    const apiKey = process.env.MAPKEY;
    const [tripTypes, setTripTypes] = useState([]);

    const [models, setModels] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalDays, setTotalDays] = useState('');
    const [farePerTrip, setFarePerTrip] = useState('');
    const [alertDialog, setAlertDialog] = useState({
        open: false,
        type: "",
        message: "",
    });

    const [distance, setDistance] = useState('');
    const [overviewPolyline, setOverviewPolyline] = useState('');
    // const [twoWayDuration, setTwoWayDuration] = useState('');
    // const [twoWayDistance, setTwoWayDistance] = useState('');
    // const [twoWayOverviewPolyline, setTwoWayOverviewPolyline] = useState('');
    const [duration, setDuration] = useState('');
    const [isZoneNotValid, setIsZoneNotValid] = useState(false);
    const [pickupErr, setPickupErr] = useState(false);
    const [dropErr, setDropErr] = useState(false);
    const [showRecurring, setShowRecurring] = useState(false);
    const [isRecurringBooking, setIsRecurringBooking] = useState('2');

    const [click, setClick] = useState(false);

    const [formData, setFormData] = useState({
        _id: '', //
        subscriptionPlanInfo: {},//subscriptionPlanInfo
        model: {},//motorModelId
        pickup: null,//pickupLocationInfo
        drop: null,//dropLocationInfo
        daySlot: [], //
        startDateTime: "", //startDateTime
        endDateTime: "", //endDateTime
        firstName: "",
        lastName: "",
        email: "",
        countryCode: "971",
        phone: "",
        companyId: '', //0
        type: '',
        tripType: '',
        fromPanel: 0,
        approxDuration: '',
        approxDistance: '',
        totalFare: '',
        farePerTrip: '',
        oneWayRoutePolyline: '',
        isRecurringBooking: isRecurringBooking,
        oneWayPickupTimeSlot: '',
        twoWayPickupTimeSlot: '',
        hours: '',
        twoWayDropLocationInfo: null,
        twoWayPickupLocationInfo: null,
        twoWayRoutePolyline: '',
        twoWayApproxDuration: '',
        twoWayApproxDistance: '',
        twoWaytotalFare: '',
        twoWayfarePerTrip: '',
    });


    const handleCurrency = () => {
        setClick((prevState) => !prevState);
        sessionStorage.setItem("bookingPath", currentPath);
        window.location.href = "/";
    };

    const calculateRouteDetails = async (pickup, drop) => {
        if (!pickup?.lat || !drop?.lat || !window.google || formData?.subscriptionPlanInfo?.tripType !== 1) return;

        const DirectionsService = new window.google.maps.DirectionsService();

        const request = {
            origin: new window.google.maps.LatLng(pickup.lat, pickup.lng),
            destination: new window.google.maps.LatLng(drop.lat, drop.lng),
            travelMode: window.google.maps.TravelMode.DRIVING,
        };

        DirectionsService.route(request, (result, status) => {
            if (status === window.google.maps.DirectionsStatus.OK) {
                const route = result.routes[0];

                // Calculate total distance and duration
                let totalDistance = 0;
                let totalDuration = 0;

                route.legs.forEach((leg) => {
                    // Distance (e.g., "12.3 km")
                    const distText = leg.distance.text;
                    const distValue = parseFloat(distText.split(" ")[0]);
                    totalDistance += distValue;

                    // Duration (e.g., "1 hour 20 mins")
                    const durParts = leg.duration.text.split(" ");
                    if (durParts.length === 2) totalDuration += parseInt(durParts[0]);
                    else if (durParts.length === 4)
                        totalDuration += parseInt(durParts[0]) * 60 + parseInt(durParts[2]);
                });



                setDistance(totalDistance.toFixed(2));
                setDuration(totalDuration);
                setOverviewPolyline(route?.overview_polyline);

                // Update your formData too
                setFormData((prev) => ({
                    ...prev,
                    approxDistance: totalDistance.toFixed(2),
                    approxDuration: totalDuration,
                    oneWayRoutePolyline: route.overview_polyline,
                }));

            } else {
                console.error("Directions request failed:", status);
            }
        });
    };

    const calculateTwoWayRouteDetails = async (pickup, drop, waypoints = []) => {

        setOverviewPolyline(null);
        if (!pickup?.lat || !drop?.lat || !window.google) return;

        const DirectionsService = new window.google.maps.DirectionsService();

        const formattedWaypoints = waypoints.map((point) => ({
            location: new window.google.maps.LatLng(point.lat, point.lng),
            stopover: true,
        }));

        const request = {
            origin: new window.google.maps.LatLng(pickup.lat, pickup.lng),
            destination: new window.google.maps.LatLng(drop.lat, drop.lng),
            waypoints: formattedWaypoints,
            optimizeWaypoints: true,
            travelMode: window.google.maps.TravelMode.DRIVING,
        };

        DirectionsService.route(request, (result, status) => {
            if (status === window.google.maps.DirectionsStatus.OK) {
                const route = result.routes[0];

                let totalDistance = 0;
                let totalDuration = 0;

                route.legs.forEach((leg) => {
                    totalDistance += leg.distance.value;
                    totalDuration += leg.duration.value;
                });

                const distanceKm = (totalDistance / 1000).toFixed(2);
                const durationMin = Math.round(totalDuration / 60);

                setDistance(distanceKm);
                setDuration(durationMin);

                setOverviewPolyline(route.overview_polyline);

                // Update your form data too
                setFormData((prev) => ({
                    ...prev,
                    approxDistance: distanceKm,
                    approxDuration: durationMin,
                    // oneWayRoutePolyline: route.overview_polyline,
                }));
            } else {
                console.error("❌ Directions request failed:", status);
            }
        });
    };


    useEffect(() => {
        setLoading(true);

        dispatch(getActiveSubscriptionPlans())
        const obj = {
            type: 1,
            companyId: 0
        };
        dispatch(getCarModels(obj));

        const id = sessionStorage.getItem("rslkeyId");

        if (id) {
            setFormData((prev) => ({
                ...prev,
                _id: id,
            }));
            setClick(false);
        } else {
            setClick(true);
        }

    }, [])


    useEffect(() => {
        if (activeSubscriptionsData) {

            setLoading(false);

            const subscriptions = activeSubscriptionsData?.responseData?.subscriptions || [];

            setTripTypes(subscriptions);

            if (subscriptions.length > 0) {
                setFormData((prev) => ({
                    ...prev,
                    subscriptionPlanInfo: subscriptions[0],
                }));
            }
        }
    }, [activeSubscriptionsData])


    useEffect(() => {
        if (!formData?.subscriptionPlanInfo) return;

        const selectedPlan = formData.subscriptionPlanInfo;
        const currentDateTime = moment();
        const planStartDate = moment(selectedPlan?.fromDateTime);
        const planEndDate = moment(selectedPlan?.endDateTime);

        // pick current date if plan start date is past
        const startDateTime = planStartDate.isAfter(currentDateTime)
            ? planStartDate
            : currentDateTime;

        // add 1 month from start date
        let endDateTime = moment(startDateTime).add(1, "month");

        // if 1-month end date exceeds planEndDate, cap it
        if (endDateTime.isAfter(planEndDate)) {
            endDateTime = planEndDate;
        }

        // Reset or set two-way details
        if (selectedPlan?.tripType !== 2) {
            setFormData((prev) => ({
                ...prev,
                twoWayApproxDistance: null,
                twoWayDropLocationInfo: null,
                twoWayPickupLocationInfo: null,
                twoWayfarePerTrip: null,
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                twoWayPickupLocationInfo: formData?.drop,
            }));
        }

        setShowRecurring(selectedPlan?.isRecurringBooking === 1);
        // setIsRecurringBooking(selectedPlan?.isRecurringBooking);

        // ✅ Final update
        setFormData((prev) => ({
            ...prev,
            startDateTime: startDateTime.format("YYYY-MM-DD"),
            endDateTime: endDateTime.format("YYYY-MM-DD"),
        }));
    }, [formData?.subscriptionPlanInfo]);

    useEffect(() => {
        if (allCarModelData?.details?.taxiMakeList?.length > 0) {
            const firstModel = allCarModelData.details.taxiMakeList[0];

            setModels(allCarModelData.details.taxiMakeList);
            setFormData((prev) => ({
                ...prev,
                model: firstModel,
            }));
        }
    }, [allCarModelData]);

    useEffect(() => {

        if (locationValidationData && formData?.drop?.lat && locationValidationData?.status !== 1) {
            // setFareLoader(true);
            setIsZoneNotValid(true);
            setDropErr(locationValidationData?.message);
        } else if (locationValidationData && locationValidationData?.status !== 1) {
            setIsZoneNotValid(true);
            // setFareLoader(true);
            setPickupErr(locationValidationData?.message);
        } else {
            setIsZoneNotValid(false);
            setPickupErr(null);
            // setFareLoader(false);
            setDropErr(null);
        }

    }, [locationValidationData]);

    useEffect(() => {
        if (tripFare?.details?.carMakeFare) {
            setFormData((prev) => ({
                ...prev,
                fare: tripFare?.details?.carMakeFare?.fare
            }));
        }
    }, [tripFare]);


    useEffect(() => {

        if (formData?.pickup?.lat && formData?.subscriptionPlanInfo) {
            const obj = {
                subscription_id: formData?.subscriptionPlanInfo?._id,
                pickup_lat: formData?.pickup?.lat,
                pickup_lng: formData?.pickup?.lng,
                model_id: formData?.model?._id,
                ...(formData?.drop?.address !== ""
                    ? {
                        isDrop: 1,
                        drop_lat: formData?.drop?.lat,
                        drop_lng: formData?.drop?.lng
                    }
                    : {}),
            }
            dispatch(validateLocation(obj));
        }

    }, [formData?.pickup, formData?.drop, formData?.model, formData?.subscriptionPlanInfo]);


    useEffect(() => {

        if (formData?.pickup?.lat && formData?.drop?.lat && formData?.model && formData?.subscriptionPlanInfo) {
            calculateRouteDetails(formData?.pickup, formData?.drop);

            if (distance && !isZoneNotValid && formData?.subscriptionPlanInfo?.tripType === 1) {
                const obj = {
                    corporate_id: 0,
                    pickup_latitude: formData?.pickup?.lat,
                    pickup_longitude: formData?.pickup?.lng,
                    company_id: 0,
                    zone_fare_applied: 0,
                    distance: distance,
                    isSubscriptionEnquiry: 1,
                    model_id: formData?.model?._id,
                    overview_polyline: overviewPolyline,
                    subscription_id: formData?.subscriptionPlanInfo?._id,
                    drop_latitude: formData?.drop?.lat,
                    drop_longitude: formData?.drop?.lng
                };

                dispatch(getFare(obj));
            }
        }
    }, [formData?.pickup?.lat, formData?.drop?.lat, formData?.model, formData?.subscriptionPlanInfo, distance]);



    useEffect(() => {
        const {
            pickup,
            drop,
            twoWayPickupLocationInfo,
            twoWayDropLocationInfo,
            model,
        } = formData || {};

        if (
            pickup?.lat &&
            pickup?.lng &&
            drop?.lat &&
            drop?.lng &&
            twoWayPickupLocationInfo?.lat &&
            twoWayPickupLocationInfo?.lng &&
            twoWayDropLocationInfo?.lat &&
            twoWayDropLocationInfo?.lng &&
            model
        ) {
            const waypoints = [{ lat: drop.lat, lng: drop.lng }];
            calculateTwoWayRouteDetails(pickup, twoWayDropLocationInfo, waypoints);
        }
    }, [
        formData?.pickup?.lat,
        formData?.pickup?.lng,
        formData?.drop?.lat,
        formData?.drop?.lng,
        formData?.twoWayPickupLocationInfo?.lat,
        formData?.twoWayPickupLocationInfo?.lng,
        formData?.twoWayDropLocationInfo?.lat,
        formData?.twoWayDropLocationInfo?.lng,
        formData?.model,
    ]);


    useEffect(() => {
        if (distance) {

            if (distance && formData?.subscriptionPlanInfo?.tripType === 2 && !isZoneNotValid) {
                const obj = {
                    corporate_id: 0,
                    pickup_latitude: formData?.pickup?.lat,
                    pickup_longitude: formData?.pickup?.lng,
                    company_id: 0,
                    zone_fare_applied: 0,
                    distance: (parseFloat(distance)) / 2,
                    isSubscriptionEnquiry: 1,
                    model_id: formData?.model?._id,
                    overview_polyline: overviewPolyline,
                    // twoway_overview_polyline: twoWayOverviewPolyline,
                    subscription_id: formData?.subscriptionPlanInfo?._id,
                    drop_latitude: formData?.twoWayDropLocationInfo?.lat,
                    drop_longitude: formData?.twoWayDropLocationInfo?.lng
                };

                dispatch(getFare(obj));
            }
        }
    }, [distance]);

    const daySlot = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const [tempSelectedDays, setTempSelectedDays] = useState([]);
    const [open, setOpen] = useState(false);


    const getDayIndex = (day) => daySlot.indexOf(day);


    const [submitted, setSubmitted] = useState(false);

    const [isSubmitting, setIsSubmitting] = useState(false);

    const [errors, setErrors] = useState({});


    // const rightRef = useRef(null);

    // useEffect(() => {
    //     const right = rightRef.current;
    //     if (!right) return;

    //     const onWheel = (e) => {
    //         const { scrollTop, scrollHeight, clientHeight } = right;
    //         const atTop = scrollTop === 0;
    //         const atBottom = scrollTop + clientHeight >= scrollHeight - 1;

    //         // allow inner scroll only if not at top/bottom
    //         const scrollingDown = e.deltaY > 0;
    //         if ((atTop && !scrollingDown) || (atBottom && scrollingDown)) {
    //             // allow normal page scroll
    //             return;
    //         }

    //         // else consume wheel for inner scroll
    //         e.stopPropagation();
    //         e.preventDefault();
    //         right.scrollTop += e.deltaY;
    //     };

    //     right.addEventListener("wheel", onWheel, { passive: false });
    //     return () => right.removeEventListener("wheel", onWheel);
    // }, []);    

    const validateForm = () => {
        const newErrors = {};

        // --- Base validations ---
        if (!formData?.subscriptionPlanInfo)
            newErrors.subscriptionPlanInfo = "Please select a Subscription Plan";
        if (!formData?.model)
            newErrors.model = "Please select a Car Model.";
        if (!formData?.pickup)
            newErrors.pickup = "Pickup location is required.";
        if (!formData?.drop)
            newErrors.drop = "Dropoff location is required.";
        if (!formData?.daySlot?.length)
            newErrors.daySlot = "Please select at least one day.";
        if (!formData?.startDateTime)
            newErrors.startDateTime = "Start date is required.";
        if (!formData?.endDateTime)
            newErrors.endDateTime = "End date is required.";
        if (!formData?.firstName?.trim())
            newErrors.firstName = "First name is required.";
        if (!formData?.lastName?.trim())
            newErrors.lastName = "Last name is required.";

        // --- Email validation ---
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!formData?.email?.trim()) {
            newErrors.email = "Email is required.";
        } else if (!emailRegex.test(formData.email.trim())) {
            newErrors.email = "Please enter a valid email address.";
        }

        // --- Phone validation ---
        const phone = formData?.phone?.trim() || "";
        if (!phone) {
            newErrors.phone = "Phone number is required.";
        } else if (!/^\d+$/.test(phone)) {
            newErrors.phone = "Phone number must contain only digits.";
        } else if (phone.length < 6) {
            newErrors.phone = "PLease Enter Valid Phone number";
        }

        // --- Day/time validation ---
        const timeErrors = {};
        if (Array.isArray(formData?.daySlot)) {
            formData.daySlot.forEach((day) => {
                const times = formData?.dayTimes?.[day];
                if (!times?.pickup) {
                    timeErrors[day] = { ...(timeErrors[day] || {}), pickup: "Pickup time required." };
                }
                if (formData?.subscriptionPlanInfo?.tripType === 2 && !times?.drop) {
                    timeErrors[day] = { ...(timeErrors[day] || {}), drop: "Two-way pickup time required." };
                }
            });
        }

        if (Object.keys(timeErrors).length > 0) {
            newErrors.dayTimes = timeErrors;
        }

        // --- Set errors ---
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    useEffect(() => {
        // Ensure all required fields are filled before calculating
        if (!formData.startDateTime || !formData.endDateTime || !formData.daySlot?.length || !formData.fare) return;

        // --- Step 1: Calculate Total Days ---
        let totalDaysCount = 0;
        let currentDate = moment(formData.startDateTime).startOf("day");
        const end = moment(formData.endDateTime).startOf("day");

        while (currentDate.isSameOrBefore(end)) {
            const dayOfWeek = currentDate.format("dddd");
            if (formData.daySlot.includes(dayOfWeek)) totalDaysCount++;
            currentDate.add(1, "day");
        }

        // --- Step 2: Fare Calculation ---
        const baseFare = Number(formData.fare) || 0;
        let tripFare = 0;

        if (totalDaysCount > 0) {
            if (formData.subscriptionPlanInfo?.tripType === 1) {
                tripFare = baseFare / totalDaysCount;
            } else {
                tripFare = baseFare / (totalDaysCount * 2);
            }
        }

        // --- Step 3: Update UI state ---
        setTotalDays(totalDaysCount);
        setFarePerTrip(tripFare);

    }, [
        formData.startDateTime,
        formData.endDateTime,
        formData.daySlot,
        formData.fare,
        formData.subscriptionPlanInfo?.tripType
    ]);


    const handleBookNow = () => {


        setSubmitted(true);

        if (!validateForm()) return;


        const id = sessionStorage.getItem("rslkeyId");

        if (!id) {
            setClick(true);
            return;

        } else {

            setFormData((prev) => ({
                ...prev,
                _id: id,
            }));
        }



        try {
            if (isZoneNotValid || pickupErr || dropErr) {
                setAlertDialog({
                    open: true,
                    type: "error",
                    message: "Please correct pickup or drop location issues before proceeding.",
                });
                return;
            }

            const areDaysSelected = formData?.daySlot?.length > 0;
            let areAllTimesValid = true;
            let arePickupDropTimesValid = true;
            let pickupDropSameTimeErrorDays = [];

            if (Array.isArray(formData?.daySlot)) {
                formData.daySlot.forEach((day) => {
                    const times = formData?.dayTimes?.[day];
                    if (!times?.pickup) areAllTimesValid = false;

                    if (formData?.subscriptionPlanInfo?.tripType === 2) {
                        if (!times?.drop) areAllTimesValid = false;

                        if (times?.pickup && times?.drop) {
                            const pickupTime = dayjs(times.pickup, "HH:mm");
                            const dropTime = dayjs(times.drop, "HH:mm");
                            if (!pickupTime.isBefore(dropTime)) {
                                arePickupDropTimesValid = false;
                                pickupDropSameTimeErrorDays.push(day);
                            }
                        }
                    }
                });
            }

            if (!areDaysSelected || !areAllTimesValid || !arePickupDropTimesValid) {
                let msg = "";
                if (!areDaysSelected) msg = "Please select at least one day.";
                else if (!areAllTimesValid) msg = "Please fill pickup/drop times for all selected days.";
                else if (!arePickupDropTimesValid)
                    msg = `Please select a valid pickup and drop time for ${pickupDropSameTimeErrorDays.join(
                        ", "
                    )}. Two Way Pickup time must be later than pickup time.`;
                setAlertDialog({ open: true, type: "error", message: msg });
                return;
            }

            // --- Step 4: Validate Date Range ---
            let totalDaysCount = 0;
            let currentDate = moment(formData.startDateTime).startOf("day");
            const end = moment(formData.endDateTime).startOf("day");

            while (currentDate.isSameOrBefore(end)) {
                const dayOfWeek = currentDate.format("dddd");
                if (formData.daySlot.includes(dayOfWeek)) totalDaysCount++;
                currentDate.add(1, "day");
            }

            setTotalDays(totalDaysCount);


            if (totalDaysCount > 22) {
                setAlertDialog({
                    open: true,
                    type: "error",
                    message: "Please select 22 days or fewer.",
                });
                return;
            }

            // --- Step 5: Map Day → Time Slots ---
            const dayMap = {
                Sunday: 0,
                Monday: 1,
                Tuesday: 2,
                Wednesday: 3,
                Thursday: 4,
                Friday: 5,
                Saturday: 6,
            };

            const oneWayPickupTimeSlot = [];
            const twoWayPickupTimeSlot = [];

            Object.entries(formData?.dayTimes || {}).forEach(([day, times]) => {
                if (times?.pickup) {
                    oneWayPickupTimeSlot.push({
                        slot: dayMap[day],
                        pickupTime: `${times.pickup}:00`,
                    });
                }
                if (times?.drop) {
                    twoWayPickupTimeSlot.push({
                        slot: dayMap[day],
                        pickupTime: `${times.drop}:00`,
                    });
                }
            });

            // --- Step 6: Fare Calculation ---
            const baseFare = formData.fare || 0;
            let tripFare = 0;
            if (formData.subscriptionPlanInfo.tripType === 1)
                tripFare = baseFare / totalDaysCount;
            else tripFare = baseFare / (totalDaysCount * 2);



            setFarePerTrip(tripFare);
            // --- Step 7: Build Payload ---

            const pickupLocationInfo = {
                latitude: formData?.pickup?.lat,
                longitude: formData?.pickup?.lng,
                address: formData?.pickup?.address,
            };


            const dropLocationInfo = {
                latitude: formData?.drop?.lat,
                longitude: formData?.drop?.lng,
                address: formData?.drop?.address,
            };

            const twoWayPickupLocationInfo = {
                latitude: formData?.twoWayPickupLocationInfo?.lat,
                longitude: formData?.twoWayPickupLocationInfo?.lng,
                address: formData?.twoWayPickupLocationInfo?.address,
            }

            const twoWayDropLocationInfo = {
                latitude: formData?.twoWayDropLocationInfo?.lat,
                longitude: formData?.twoWayDropLocationInfo?.lng,
                address: formData?.twoWayDropLocationInfo?.address,
            }

            const payload = {
                _id: formData._id,
                firstName: formData.firstName,
                lastName: formData.lastName,
                email: formData.email,
                motorModelId: formData.model?._id,
                companyId: formData.companyId || 0,
                pickupLocationInfo,
                dropLocationInfo,
                subscriptionPlanInfo: formData.subscriptionPlanInfo,
                type: formData.subscriptionPlanInfo?.type,
                tripType: formData.subscriptionPlanInfo?.tripType,
                fromPanel: 2,
                approxDuration: formData.approxDuration,
                approxDistance: formData.approxDistance,
                countryCode: formData.countryCode,
                totalFare: baseFare,
                farePerTrip: tripFare,
                startDateTime: moment(formData.startDateTime).format("YYYY-MM-DD HH:mm:ss"),
                endDateTime: moment(formData.endDateTime).format("YYYY-MM-DD HH:mm:ss"),
                phoneNumber: formData.phone,
                daySlot: formData.daySlot.map((day) => dayMap[day]),
                oneWayRoutePolyline: overviewPolyline,
                isRecurringBooking: Number(formData.isRecurringBooking),
                oneWayPickupTimeSlot,
                twoWayPickupTimeSlot,
            };

            // --- Step 8: Add Two-Way Info (if applicable) ---
            if (formData.subscriptionPlanInfo.tripType === 2) {
                payload.hours = formData.hours;
                payload.twoWayDropLocationInfo = twoWayDropLocationInfo;
                payload.twoWayPickupLocationInfo = twoWayPickupLocationInfo;
                payload.twoWayRoutePolyline = overviewPolyline;
                payload.twoWayApproxDuration = duration;
                payload.twoWayApproxDistance = distance;
                payload.twoWaytotalFare = baseFare;
                payload.twoWayfarePerTrip = tripFare;
            }

            // --- Step 9: Submit to API ---            
            setIsSubmitting(true);

            dispatch(createEnquiry(payload));

        } catch (error) {
            console.error("Booking error:", error);
        }

    };


    const selectRef = useRef(null);


    const handleCloseMenu = () => {
        // Close the select dropdown manually
        if (selectRef.current) {
            const event = new MouseEvent("mousedown", { bubbles: true });
            selectRef.current.dispatchEvent(event);
        }
        setOpen(false);
    };


    useEffect(() => {
        setIsSubmitting(false);
        if (createEnquiryRes) {

            if (createEnquiryRes?.status === 1) {
                setAlertDialog({
                    open: true,
                    type: "success",
                    message: createEnquiryRes?.message
                });
            } else {
                setAlertDialog({
                    open: true,
                    type: "error",
                    message: createEnquiryRes?.message
                });
            }
        }
    }, [createEnquiryRes]);


    const handleDayChange = (event) => {
        const { value } = event.target;

        // Handle "All" selection toggle
        if (value.includes("All")) {
            if (tempSelectedDays.length === 7) {
                setTempSelectedDays([]);
            } else {
                setTempSelectedDays([...Array(7).keys()]); // all days selected (0–6)
            }
            return;
        }

        const selectedIndexes = value.map((day) => getDayIndex(day));

        if (selectedIndexes.length === 7) {
            setTempSelectedDays([...Array(7).keys()]);
        } else {
            setTempSelectedDays(selectedIndexes);
        }
    };


    useEffect(() => {
        if (click) {
            lockScrollNew(); // Lock scroll when `click` is true
        } else {
            unlockScrollNew(); // Unlock scroll when `click` is false
        }

        // Cleanup: Unlock scroll when the component unmounts or when `click` changes
        return () => {
            unlockScrollNew();
        };
    }, [click]);

    return (
        <>
            <Seo meta={meta} />
            <Header3 />

            <section
                className="hero"
                style={{
                    position: "relative",
                    width: "100%",
                    height: bannerHeight(),
                    overflow: "hidden",
                }}
            >
                {/* Fixed background layer */}
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: bannerHeight(),
                        zIndex: 0,
                    }}
                >
                    {/* BG image */}
                    <Image
                        src={`${process.env.IMAGE_BASE_URL}/images/bannerImage/1761200763449.svg`}
                        alt="limousine"
                        fill
                        priority
                        sizes="100vw"
                        style={{ objectFit: "cover" }}
                    />
                    {/* Gradient overlay */}
                    <div
                        style={{
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            top: 0,
                            background: "linear-gradient(to top, rgb(0 0 0 / 79%) 0%, rgba(0, 0, 0, 0) 50%)",
                            zIndex: 1,
                            pointerEvents: "none",
                        }}
                    />
                    {/* dark gradient overlay */}
                    {/* <div className="overlay" aria-hidden="true" /> */}

                    {/* content */}
                    <div className="content">
                        <h1 className="title jura">
                            School and university
                            {" "}<span className="scribble-wrap">
                                <span className="scribble-text">subscriptions</span>
                                {/* teal hand-drawn oval */}
                                <img
                                    src="/img/Oval.svg"
                                    alt=""
                                    className="scribble"
                                />
                            </span>
                        </h1>

                        <div className="cta">
                            <CtaButton label="Book Now" endIconSrc="/img/header/VectorDown.svg" />
                        </div>
                    </div>
                </div>
            </section>
            <style jsx>{`
        :global(html, body) {
         scroll-behavior: smooth;
          overflow-x: hidden;
        }

        .hero {
          position: relative;
          width: 100%;
        //   min-height: clamp(80vh, 72vh, 80vh);
          min-height: ${bannerHeight()};
          border-radius: 0;
          isolation: isolate; /* ensure overlay/contents stack correctly */
        }

        .overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
              to top,
              rgba(0, 0, 0, 0.78) 0%,
              rgba(0, 0, 0, 0.55) 35%,
              rgba(0, 0, 0, 0.08) 70%,
              rgba(0, 0, 0, 0) 100%
            ),
            radial-gradient(60% 60% at 50% 50%, rgba(0, 0, 0, 0.25), transparent 70%);
          z-index: 1;
          pointer-events: none;
        }

        .content {
          position: absolute;
          inset: 0;
          z-index: 2;
          display: grid;
          place-items: end center;
          padding: clamp(16px, 4vw, 28px);
          /* push content slightly above bottom like the mock */
          align-content: end;
        //   gap: clamp(16px, 3vh, 28px);
        //   padding-bottom: clamp(36px, 10vh, 40px);
          text-align: center;
        }

        .title {
          color: #ffffff;
          font-weight: 700;
          letter-spacing: 0.02em;
          line-height: 1;
          margin: 0;
          /* responsive font like the design */
          font-size: clamp(10px, 6.5vw, 52px);
          text-shadow: 0 2px 10px rgba(0, 0, 0, 0.4);
        }

        .scribble-wrap {
          position: relative;
          display: inline-block;
        }

        .scribble-text {
          position: relative;
          z-index: 2;
        }

        .scribble {
          position: absolute;
          z-index: 1;
          left: 0.15em;
          top: 0px;
          width: clamp(7.5em, 14vw, 13em); /* scales with font size */
          height: auto;
          transform: rotate(0deg);
          pointer-events: none;
          filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.25));
          opacity: 0.95;
        }

        .cta {
          display: flex;
          justify-content: center;
          margin-top:1%;
        }

        /* Button polish to match mock (rounded pill + subtle shadow) */
        :global(.cta button),
        :global(.cta a) {
          border-radius: 999px !important;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
        }

        /* Responsive tweaks */
        @media (max-width: 768px) {
          .content {
            padding-bottom: 48px;
          }
          .scribble {
            left: -0.3em;
            top: 10px;
          }
        }

        @media (max-width: 420px) {
          .title {
            line-height: 1.08;
            letter-spacing: 0.01em;
          }
          .scribble {
            width: 8.8em;
          }
        }
      `}</style>

            {/* 👇 important: push content BELOW fixed hero */}
            <Box
                id="fleet"
                sx={{
                    position: "relative",
                    zIndex: 3,
                    pt: `${bannerHeight()}px`,
                    background: "#fff"
                }}
            >
                <Box sx={{ py: { xs: 4, md: 4 }, px: { xs: 2, md: 4 } }}>
                    <Box textAlign="center" mb={4}>
                        <Heading title={"Starting From AED 600 Per Week"} />
                    </Box>

                    <Box display="flex" justifyContent="center" gap={3} flexWrap="wrap">
                        {["Priority Access", "Flexible Scheduling", "Best Price Guarantee"].map((i) => (
                            <Card
                                key={i}
                                sx={{
                                    width: { xs: "100%", sm: 300, md: 340 },
                                    height: 100,
                                    borderRadius: "16px",
                                    // background: "linear-gradient(135deg, #6fd6d3 0%, #008c89 100%)",
                                    background: "linear-gradient(to bottom, #75C4C5 0%, #0D8196 100%)",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    color: "#fff",
                                    pl: 3,
                                    position: "relative",
                                    overflow: "hidden",
                                    boxShadow: "0px 8px 24px rgba(0, 140, 137, 0.2)",
                                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                    "&:hover": {
                                        transform: "translateY(-4px)",
                                        boxShadow: "0px 12px 32px rgba(0, 140, 137, 0.3)",
                                    },
                                }}
                            >
                                <Typography fontWeight={600} sx={{ fontSize: { xs: 14, md: 18 } }}>
                                    {i}
                                </Typography>

                                <Box
                                    component="img"
                                    src={`${process.env.IMAGE_BASE_URL}/images/bannerImage/1761398975629.svg`}
                                    alt="car"
                                    sx={{
                                        width: 150,
                                        height: "auto",
                                        objectFit: "contain",
                                        filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))",
                                        position: "absolute",
                                        right: "-20px"
                                    }}
                                />
                            </Card>
                        ))}
                    </Box>
                </Box>

                <Box
                    sx={{
                        pt: { xs: 2, md: 2 },
                        pb: { xs: 4, md: 4 },
                        px: { xs: 2, md: 4 },
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <Grid
                        container
                        spacing={3}
                        sx={{
                            maxWidth: "1400px",
                            display: "flex",
                            alignItems: "stretch",
                        }}
                    >
                        {/* Left Map Section */}
                        <Grid
                            item
                            xs={12}
                            md={4}
                            sx={{
                                position: "sticky",    // Sticky positioning for the map
                                top: "84px",           // Pushed below header (adjust header height if needed)
                                height: "calc(100vh - 84px)", // Ensure map fills remaining space
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            <Box
                                sx={{
                                    position: "relative",
                                    flex: 1,
                                    minHeight: { xs: 300, md: "100%" },
                                    backgroundColor: "#f3f4f6",
                                    borderRadius: "16px",
                                    overflow: "hidden",
                                    boxShadow: "0px 4px 12px rgba(0,0,0,0.08)",
                                }}
                            >
                                <GoogleMap apiKey={apiKey} formData={formData} overviewPolyline={overviewPolyline} totalDays={totalDays} farePerTrip={farePerTrip} totalFare={formData?.fare} />
                            </Box>
                        </Grid>

                        {/* Right Section */}
                        <Grid item xs={12} md={8}>
                            <Card
                                sx={{
                                    borderRadius: "20px",
                                    height: "100%",
                                    border: "1px solid #E5E7EB",
                                    boxShadow: "0px 4px 16px rgba(0,0,0,0.08)",
                                    display: "flex",
                                    flexDirection: "column",
                                    backgroundColor: "#fff",
                                    overflow: "hidden",
                                }}
                            >
                                {/* Header */}
                                <Box
                                    sx={{
                                        px: 4,
                                        py: 3,
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        borderBottom: "1px solid #E5E7EB",
                                    }}
                                >
                                    <Typography variant="h6" fontWeight={700} color="#000">
                                        Book Now
                                    </Typography>
                                </Box>

                                {/* Trip Type Buttons */}
                                <Box sx={{
                                    display: "flex", gap: 2, p: 3, flexWrap: "nowrap", overflowX: "auto", // smoother scrolling
                                    scrollbarWidth: "none",
                                    msOverflowStyle: "none",
                                    "&::-webkit-scrollbar": {
                                        display: "none",
                                    },
                                }}>

                                    {loading ? (
                                        // ✅ Show skeleton loader while fetching tripTypes
                                        Array.from(new Array(4)).map((_, index) => (
                                            <Skeleton
                                                key={index}
                                                variant="rectangular"
                                                width={140}
                                                height={48}
                                                sx={{ borderRadius: "12px" }}
                                            />
                                        ))
                                    ) : tripTypes && tripTypes.length > 0 ? (
                                        tripTypes.map((trip) => {
                                            const isSelected = formData?.subscriptionPlanInfo._id === trip._id;
                                            return (
                                                <Button
                                                    key={trip._id}
                                                    onClick={() =>
                                                        setFormData({ ...formData, subscriptionPlanInfo: trip })
                                                    }
                                                    disableElevation
                                                    sx={{
                                                        minWidth: "140px",
                                                        height: "60px",
                                                        borderRadius: "12px",
                                                        fontWeight: 600,
                                                        fontSize: "15px",
                                                        textTransform: "none",
                                                        color: isSelected ? "#fff" : "#6b7280",
                                                        border: isSelected ? "none" : "2px solid #e5e7eb",
                                                        background: isSelected
                                                            // ? "linear-gradient(135deg, #7cd1cf 0%, #008c89 100%)"
                                                            ? "linear-gradient(to bottom, #75C4C5 0%, #0D8196 100%)"
                                                            : "#fff",
                                                        transition: "all 0.3s ease",
                                                        "&:hover": {
                                                            background: isSelected
                                                                // ? "linear-gradient(135deg, #6cc1bf 0%, #007c79 100%)"
                                                                ? "linear-gradient(to bottom, #75C4C5 0%, #0D8196 100%)"
                                                                : "#f3f4f6",
                                                            borderColor: "#d1d5db",
                                                        },
                                                    }}
                                                >
                                                    {trip.planName}
                                                </Button>
                                            );
                                        })
                                    ) : (
                                        // ✅ Show “No Data Found” if empty
                                        <Typography variant="body2" color="text.secondary">
                                            No subscription plans available.
                                        </Typography>
                                    )}
                                </Box>
                                {errors.subscriptionPlanInfo && (
                                    <Typography color="error" variant="caption" sx={{ pl: 4, mb: 1 }}>
                                        {errors.subscriptionPlanInfo}
                                    </Typography>
                                )}

                                {/* <Box sx={{
                                display: "flex", gap: 2, p: 3, flexWrap: "nowrap", overflowX: "auto", // smoother scrolling
                                scrollbarWidth: "none",
                                msOverflowStyle: "none",
                                "&::-webkit-scrollbar": {
                                    display: "none",
                                },
                            }}>
                                {models?.map((trip) => {
                                    const isSelected = formData?.model._id === trip._id                                    

                                    return (
                                        <Button
                                            key={trip._id}
                                            onClick={() => setFormData({ ...formData, model: trip })}
                                            disableElevation
                                            sx={{
                                                minWidth: "140px",
                                                height: "48px",
                                                borderRadius: "12px",
                                                fontWeight: 600,
                                                fontSize: "15px",
                                                textTransform: "none",
                                                color: isSelected ? "#fff" : "#6b7280",
                                                border: isSelected ? "none" : "2px solid #e5e7eb",
                                                background: isSelected ? "linear-gradient(135deg, #7cd1cf 0%, #008c89 100%)" : "#fff",
                                                transition: "all 0.3s ease",
                                                "&:hover": {
                                                    background: isSelected ? "linear-gradient(135deg, #6cc1bf 0%, #007c79 100%)" : "#f3f4f6",
                                                    borderColor: "#d1d5db",
                                                },
                                            }}
                                        >
                                            {trip.model_name}
                                        </Button>
                                    )
                                })}
                            </Box> */}


                                {/* Location Section */}
                                <Box sx={{ px: 4, pb: 4 }}>
                                    <Typography fontWeight={700} sx={{ fontSize: 16, mb: 1.5 }}>
                                        Location
                                    </Typography>

                                    <Grid container spacing={1.5}>
                                        {/* Pickup */}
                                        <Grid item xs={12} sm={6}>
                                            <PickupLocation
                                                type="pickup"
                                                label="Pickup Location"
                                                value={formData.pickup}
                                                onChange={(val) => {
                                                    setFormData((prev) => ({ ...prev, pickup: val }));
                                                    if (errors.pickup)
                                                        setErrors((prev) => ({ ...prev, pickup: "" }));
                                                }}
                                                placeholder="Pickup Location"
                                                newDesign
                                            />
                                            {errors.pickup && (
                                                <Typography color="error" variant="caption">
                                                    {errors.pickup}
                                                </Typography>
                                            )}
                                            {isZoneNotValid && pickupErr && (
                                                <Typography color="error" variant="caption">
                                                    {pickupErr}
                                                </Typography>
                                            )}

                                        </Grid>

                                        {/* Drop */}
                                        <Grid item xs={12} sm={6}>
                                            <PickupLocation
                                                type="drop"
                                                label="Dropoff Location"
                                                value={formData.drop}
                                                onChange={(val) => {
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        drop: val,
                                                        twoWayPickupLocationInfo: val,
                                                    }));
                                                    if (errors.drop) setErrors((prev) => ({ ...prev, drop: "" }));
                                                }}
                                                placeholder="Dropoff Location"
                                                newDesign
                                            />
                                            {errors.drop && (
                                                <Typography color="error" variant="caption">
                                                    {errors.drop}
                                                </Typography>
                                            )}
                                            {isZoneNotValid && dropErr && (
                                                <Typography color="error" variant="caption">
                                                    {dropErr}
                                                </Typography>
                                            )}

                                        </Grid>
                                    </Grid>

                                    {/* Two-Way Section */}
                                    {formData?.subscriptionPlanInfo?.tripType === 2 && (
                                        <Grid container spacing={1.5} sx={{ mt: 1 }}>
                                            <Grid item xs={12} sm={6}>
                                                <PickupLocation
                                                    type="twowaypickup"
                                                    label="Two-Way Pickup Location"
                                                    value={formData.drop}
                                                    placeholder="Two-Way Pickup Location"
                                                    disabled
                                                    newDesign
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <PickupLocation
                                                    type="twowaydrop"
                                                    label="Two-Way Dropoff Location"
                                                    value={formData.twoWayDropLocationInfo}
                                                    onChange={(val) => {
                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            twoWayDropLocationInfo: val,
                                                        }));
                                                        if (errors.twoWayDropLocationInfo)
                                                            setErrors((prev) => ({ ...prev, twoWayDropLocationInfo: "" }));
                                                    }}
                                                    placeholder="Two-Way Dropoff Location"
                                                    newDesign
                                                />
                                            </Grid>
                                        </Grid>
                                    )}

                                    {/* Day Slot */}
                                    {/* <Typography fontWeight={700} sx={{ fontSize: 16, mt: 3, mb: 1.5 }}>
                                    Day Slot
                                </Typography>
                                <Select
                                    multiple
                                    fullWidth
                                    value={formData.daySlot}
                                    onChange={(e) => {
                                        setFormData((prev) => ({ ...prev, daySlot: e.target.value }));
                                        if (errors.daySlot)
                                            setErrors((prev) => ({ ...prev, daySlot: "" }));
                                    }}
                                    input={<OutlinedInput />}
                                    renderValue={(selected) =>
                                        selected.length === 0 ? "Select days" : selected.join(", ")
                                    }
                                    sx={{
                                        borderRadius: "50px",
                                        backgroundColor: "#fff",
                                        "& .MuiOutlinedInput-notchedOutline": { borderColor: "#E5E7EB" },
                                    }}
                                    error={!!errors.daySlot}
                                >
                                    {[
                                        "Sunday",
                                        "Monday",
                                        "Tuesday",
                                        "Wednesday",
                                        "Thursday",
                                        "Friday",
                                        "Saturday",
                                    ].map((day) => (
                                        <MenuItem key={day} value={day}>
                                            <Checkbox checked={formData.daySlot.includes(day)} />
                                            <ListItemText primary={day} />
                                        </MenuItem>
                                    ))}
                                </Select>
                                {errors.daySlot && (
                                    <Typography color="error" variant="caption" sx={{ mt: 0.5 }}>
                                        {errors.daySlot}
                                    </Typography>
                                )} */}

                                    <Typography fontWeight={700} sx={{ fontSize: 16, mt: 3, mb: 1.5 }}>
                                        Day Slot
                                    </Typography>

                                    <Select
                                        multiple
                                        fullWidth
                                        open={open}
                                        onOpen={() => setOpen(true)}
                                        // onClose={() => setOpen(false)}
                                        // onClick={() => setOpen(true)}
                                        value={tempSelectedDays}
                                        input={<OutlinedInput />}
                                        renderValue={(selected) =>
                                            selected.length === 0 ? "Select days" : selected.join(", ")
                                        }
                                        sx={{
                                            borderRadius: "50px",
                                            backgroundColor: "#fff",
                                            "& .MuiOutlinedInput-notchedOutline": { borderColor: "#E5E7EB" },
                                        }}
                                        error={!!errors.daySlot}
                                        ref={selectRef}
                                    >
                                        {daySlot.map((day) => (
                                            <MenuItem
                                                key={day}
                                                value={day}
                                                onClick={() => {
                                                    setTempSelectedDays((prev) =>
                                                        prev.includes(day)
                                                            ? prev.filter((d) => d !== day)
                                                            : [...prev, day]
                                                    );
                                                }}
                                            >
                                                <Checkbox checked={tempSelectedDays.includes(day)} />
                                                <ListItemText primary={day} />
                                            </MenuItem>
                                        ))}

                                        {/* Divider */}
                                        <Box sx={{ borderTop: "1px solid #eee", my: 1 }} />

                                        {/* OK / Cancel buttons */}
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                                gap: 1,
                                                px: 2,
                                                pb: 1.5,
                                            }}
                                        >
                                            <Button
                                                size="small"
                                                onClick={() => {
                                                    setTempSelectedDays(formData.daySlot || []);
                                                    handleCloseMenu(); // ✅ Close dropdown
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                size="small"
                                                variant="contained"
                                                onClick={() => {
                                                    setFormData((prev) => ({ ...prev, daySlot: tempSelectedDays }));
                                                    if (errors.daySlot)
                                                        setErrors((prev) => ({ ...prev, daySlot: "" }));
                                                    handleCloseMenu(); // ✅ Close dropdown
                                                }}
                                            >
                                                OK
                                            </Button>
                                        </Box>
                                    </Select>

                                    {errors.daySlot && (
                                        <Typography color="error" variant="caption" sx={{ mt: 0.5 }}>
                                            {errors.daySlot}
                                        </Typography>
                                    )}


                                    {/* ✅ Day-Wise Pickup/Drop Time */}
                                    {formData?.daySlot?.length > 0 && (
                                        <Box sx={{ mt: 3 }}>
                                            {formData.daySlot.map((day) => {
                                                const isTodaySelected =
                                                    new Date(formData?.startDateTime).toDateString() ===
                                                    new Date().toDateString();
                                                const currentTime = new Date().toLocaleTimeString("en-GB", {
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                });

                                                return (
                                                    <Grid key={day} container alignItems="center" spacing={2} sx={{ mb: 1 }}>
                                                        <Grid item xs={12} sm={3}>
                                                            <Typography sx={{ fontWeight: 600, fontSize: 15, pl: 1 }}>
                                                                {day}
                                                            </Typography>
                                                        </Grid>

                                                        {/* One-way Pickup */}
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            sm={formData?.subscriptionPlanInfo?.tripType === 2 ? 4.5 : 6}
                                                        >
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DesktopTimePicker
                                                                    ampm
                                                                    label="Pickup Time"
                                                                    value={
                                                                        formData?.dayTimes?.[day]?.pickup
                                                                            ? dayjs(formData.dayTimes[day].pickup, "HH:mm")
                                                                            : null
                                                                    }
                                                                    onChange={(v) => {
                                                                        const newVal = v ? v.format("HH:mm") : "";
                                                                        setFormData((prev) => ({
                                                                            ...prev,
                                                                            dayTimes: {
                                                                                ...prev.dayTimes,
                                                                                [day]: {
                                                                                    ...prev.dayTimes?.[day],
                                                                                    pickup: newVal,
                                                                                },
                                                                            },
                                                                        }));
                                                                        if (errors?.dayTimes?.[day]?.pickup)
                                                                            setErrors((prev) => ({
                                                                                ...prev,
                                                                                dayTimes: {
                                                                                    ...prev.dayTimes,
                                                                                    [day]: { ...prev.dayTimes?.[day], pickup: "" },
                                                                                },
                                                                            }));
                                                                    }}

                                                                    // minTime={
                                                                    //     formData?.dayTimes?.[day]?.pickup
                                                                    //         ? dayjs(formData.dayTimes[day].pickup, "HH:mm").add(1, "minute")
                                                                    //         : dayjs(formData?.startDateTime).isSame(dayjs(), "day") &&
                                                                    //             day === dayjs().format("dddd")
                                                                    //             ? dayjs()
                                                                    //             : undefined
                                                                    // }
                                                                    slotProps={{
                                                                        textField: {
                                                                            fullWidth: true,
                                                                            error: submitted && !!errors?.dayTimes?.[day]?.pickup,
                                                                            helperText:
                                                                                submitted && errors?.dayTimes?.[day]?.pickup
                                                                                    ? errors?.dayTimes?.[day]?.pickup
                                                                                    : "",
                                                                            InputProps: {
                                                                                sx: {
                                                                                    borderRadius: "50px",
                                                                                    backgroundColor: "#fff",
                                                                                },
                                                                            },
                                                                        },
                                                                    }}
                                                                />

                                                            </LocalizationProvider>
                                                        </Grid>

                                                        {/* Two-way Drop Time */}
                                                        {formData?.subscriptionPlanInfo?.tripType === 2 && (
                                                            <Grid item xs={12} sm={4.5}>
                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                    <DesktopTimePicker
                                                                        ampm
                                                                        label="Two-way Pickup Time"
                                                                        value={
                                                                            formData?.dayTimes?.[day]?.drop
                                                                                ? dayjs(formData.dayTimes[day].drop, "HH:mm")
                                                                                : null
                                                                        }
                                                                        onChange={(v) => {
                                                                            const newVal = v ? v.format("HH:mm") : "";
                                                                            setFormData((prev) => ({
                                                                                ...prev,
                                                                                dayTimes: {
                                                                                    ...prev.dayTimes,
                                                                                    [day]: {
                                                                                        ...prev.dayTimes?.[day],
                                                                                        drop: newVal,
                                                                                    },
                                                                                },
                                                                            }));
                                                                            if (errors?.dayTimes?.[day]?.drop)
                                                                                setErrors((prev) => ({
                                                                                    ...prev,
                                                                                    dayTimes: {
                                                                                        ...prev.dayTimes,
                                                                                        [day]: { ...prev.dayTimes?.[day], drop: "" },
                                                                                    },
                                                                                }));
                                                                        }}
                                                                        // minTime={
                                                                        //     formData?.dayTimes?.[day]?.pickup
                                                                        //         ? dayjs(formData.dayTimes[day].pickup, "HH:mm").add(5, "minute") // 5 min buffer
                                                                        //         : dayjs(formData?.startDateTime).isSame(dayjs(), "day") &&
                                                                        //             day === dayjs().format("dddd")
                                                                        //             ? dayjs() // restrict past time only if current day
                                                                        //             : undefined
                                                                        // }
                                                                        slotProps={{
                                                                            textField: {
                                                                                fullWidth: true,
                                                                                error: submitted && !!errors?.dayTimes?.[day]?.drop,
                                                                                helperText:
                                                                                    submitted && errors?.dayTimes?.[day]?.drop
                                                                                        ? errors?.dayTimes?.[day]?.drop
                                                                                        : "",
                                                                                InputProps: {
                                                                                    sx: {
                                                                                        borderRadius: "50px",
                                                                                        backgroundColor: "#fff",
                                                                                    },
                                                                                },
                                                                            },
                                                                        }}
                                                                    />

                                                                </LocalizationProvider>
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                );
                                            })}
                                        </Box>
                                    )}

                                    {/* ✅ Date Range */}
                                    <Typography fontWeight={700} sx={{ fontSize: 16, mt: 3, mb: 1.5 }}>
                                        Date
                                    </Typography>
                                    <Grid container spacing={2}>
                                        {/* Start Date */}
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                type="date"
                                                fullWidth
                                                value={formData.startDateTime}
                                                onChange={(e) => {
                                                    const selectedDate = e.target.value;
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        startDateTime: selectedDate,
                                                        endDateTime:
                                                            prev.endDateTime && moment(selectedDate).isAfter(prev.endDateTime)
                                                                ? ""
                                                                : prev.endDateTime,
                                                    }));
                                                    // clear errors if corrected
                                                    setErrors((prev) => ({
                                                        ...prev,
                                                        startDateTime: "",
                                                        endDateTime:
                                                            prev.endDateTime && moment(selectedDate).isAfter(prev.endDateTime)
                                                                ? "End date must be after start date."
                                                                : "",
                                                    }));
                                                }}
                                                inputProps={{
                                                    min: moment().format("YYYY-MM-DD"), // 🔒 disable past dates
                                                }}
                                                error={!!errors.startDateTime}
                                                helperText={errors.startDateTime || ""}
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        borderRadius: "50px",
                                                        backgroundColor: "#fff",
                                                    },
                                                }}
                                            />
                                        </Grid>

                                        {/* End Date */}
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                type="date"
                                                fullWidth
                                                value={formData.endDateTime}
                                                onChange={(e) => {
                                                    const selectedDate = e.target.value;
                                                    const startDate = moment(formData?.startDateTime);
                                                    const planEndDate = moment(formData?.subscriptionPlanInfo?.endDateTime);

                                                    if (moment(selectedDate).isBefore(startDate)) {
                                                        setErrors((prev) => ({
                                                            ...prev,
                                                            endDateTime: "End date must be after start date.",
                                                        }));
                                                    } else if (moment(selectedDate).isAfter(planEndDate)) {
                                                        setErrors((prev) => ({
                                                            ...prev,
                                                            endDateTime: `End date cannot exceed plan end date (${planEndDate.format("DD MMM YYYY")}).`,
                                                        }));
                                                    } else {
                                                        setFormData((prev) => ({ ...prev, endDateTime: selectedDate }));
                                                        setErrors((prev) => ({ ...prev, endDateTime: "" }));
                                                    }
                                                }}
                                                inputProps={{
                                                    min: moment(formData.startDateTime || new Date()).format("YYYY-MM-DD"),
                                                    max: moment(formData?.subscriptionPlanInfo?.endDateTime).format("YYYY-MM-DD"), // ✅ Restrict beyond planEndDate
                                                }}
                                                error={!!errors.endDateTime}
                                                helperText={errors.endDateTime || ""}
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        borderRadius: "50px",
                                                        backgroundColor: "#fff",
                                                    },
                                                }}
                                            />
                                        </Grid>

                                    </Grid>


                                    {showRecurring && (
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                                mt: 3,
                                                color: "#111827",
                                            }}
                                        >
                                            <Radio
                                                checked={isRecurringBooking === '1'}
                                                onClick={() => {
                                                    const nextValue = isRecurringBooking === "1" ? "2" : "1"; // 1 = on, 2 = off
                                                    setIsRecurringBooking(nextValue);
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        isRecurringBooking: nextValue,
                                                    }));
                                                }}
                                                sx={{
                                                    color: "#d1d5db",
                                                    "&.Mui-checked": {
                                                        color: "#0D8196",
                                                    },
                                                }}
                                            />
                                            <Typography sx={{ fontWeight: 600, fontSize: 15, color: "#000" }}>
                                                Recurring Booking
                                            </Typography>
                                            <Tooltip title="Enable this to Create Recurring Booking" arrow>
                                                <IconButton size="small" disableRipple>
                                                    <InfoOutlinedIcon sx={{ fontSize: 18, color: "#6b7280" }} />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                    )}

                                    <Divider sx={{ my: 3 }} />


                                    {/* Customer Details */}
                                    <Typography fontWeight={700} sx={{ fontSize: 16, mt: 4, mb: 1.5 }}>
                                        Customer Details
                                    </Typography>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                placeholder="Enter your first name"
                                                fullWidth
                                                value={formData.firstName}
                                                onChange={(e) => {
                                                    setFormData((prev) => ({ ...prev, firstName: e.target.value }));
                                                    if (errors.firstName)
                                                        setErrors((prev) => ({ ...prev, firstName: "" }));
                                                }}
                                                error={!!errors.firstName}
                                                helperText={errors.firstName || ""}
                                                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "50px" } }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                placeholder="Enter your last name"
                                                fullWidth
                                                value={formData.lastName}
                                                onChange={(e) => {
                                                    setFormData((prev) => ({ ...prev, lastName: e.target.value }));
                                                    if (errors.lastName)
                                                        setErrors((prev) => ({ ...prev, lastName: "" }));
                                                }}
                                                error={!!errors.lastName}
                                                helperText={errors.lastName || ""}
                                                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "50px" } }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                type="email"
                                                placeholder="Enter your email address"
                                                fullWidth
                                                value={formData.email}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setFormData((prev) => ({ ...prev, email: value }));

                                                    // Clear error when typing valid pattern
                                                    if (errors.email) {
                                                        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                                        if (emailRegex.test(value)) {
                                                            setErrors((prev) => ({ ...prev, email: "" }));
                                                        }
                                                    }
                                                }}
                                                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "50px" } }}
                                                error={!!errors.email}
                                                helperText={errors.email || ""}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} display="flex">
                                            {/* Country Code Selector */}
                                            {/* <Autocomplete
                                            disableClearable
                                            options={countries}
                                            getOptionLabel={(option) => `${option.code} (+${option.phone})`}
                                            value={
                                                countries.find((c) => c.phone === formData?.countryCode) || countries[1]
                                            }
                                            onChange={(e, value) =>
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    countryCode: value.phone,
                                                }))
                                            }
                                            sx={{
                                                width: "35%",
                                                "& .MuiOutlinedInput-root": {
                                                    borderRadius: "50px 0 0 50px",
                                                    backgroundColor: "#fff",
                                                    // height: "46px",
                                                    "& fieldset": { borderColor: "#ccc" },
                                                    "&:hover fieldset": { borderColor: "#999" },
                                                    "&.Mui-focused fieldset": { borderColor: "#1976d2" },
                                                },
                                                "& .MuiInputBase-input": {
                                                    fontSize: 15,
                                                    pl: 2,
                                                },
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} variant="outlined" />
                                            )}
                                        /> */}

                                            {/* Phone Number Input */}
                                            {/* <TextField
                                            fullWidth
                                            placeholder="Enter phone number"
                                            value={formData?.phone}
                                            onChange={(e) => {
                                                const numericValue = e.target.value.replace(/\D/g, "");
                                                if (numericValue.length <= 10) {
                                                    setFormData((prev) => ({ ...prev, phone: numericValue }));
                                                }

                                                if (
                                                    errors.phone &&
                                                    numericValue.length === 10 &&
                                                    /^\d+$/.test(numericValue)
                                                ) {
                                                    setErrors((prev) => ({ ...prev, phone: "" }));
                                                }
                                            }}
                                            inputProps={{ maxLength: 10 }}
                                            error={!!errors.phone}
                                            helperText={errors.phone || ""}
                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    borderRadius: "0 50px 50px 0",
                                                    backgroundColor: "#fff",
                                                    // height: "46px",
                                                    "& fieldset": { borderColor: "#ccc" },
                                                    "&:hover fieldset": { borderColor: "#999" },
                                                    "&.Mui-focused fieldset": { borderColor: "#1976d2" },
                                                },
                                                "& .MuiInputBase-input": {
                                                    fontSize: 15,
                                                    pl: 2,
                                                },
                                                "& .MuiFormHelperText-root": {
                                                    ml: 1.5,
                                                    mt: 0.5,
                                                },
                                            }}
                                        /> */}

                                            <PhoneInput
                                                value={formData.phone}
                                                countryCode={formData.countryCode}
                                                onChange={(countryCode, phone) =>
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        countryCode,
                                                        phone,
                                                    }))
                                                }
                                                error={!!errors.phone}
                                                helperText={errors.phone}
                                                width="100%"
                                            />
                                        </Grid>



                                    </Grid>

                                    <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4, position: "relative" }}>
                                        <CtaButton
                                            label={isSubmitting ? "Booking..." : "Book Now"}
                                            onClick={handleBookNow}
                                            loader={isSubmitting}
                                            disabled={isSubmitting}
                                        />
                                    </Box>


                                </Box>
                            </Card>
                        </Grid>

                    </Grid>
                </Box>

                <CommonAlertDialog
                    open={alertDialog.open}
                    type={alertDialog.type}
                    message={alertDialog.message}
                    onClose={() => setAlertDialog({ ...alertDialog, open: false })}
                />

                {/* App Banner */}
                <Box sx={{ py: 4, px: { xs: 2, md: 4 } }}>
                    <RslSuperAppBanner />
                </Box>

                <Footer3 />
            </Box>

            <div
                className={`currencyMenu js-currencyMenu ${click ? "" : "is-hidden"}`}
            >
                <div className="currencyMenu__bg" onClick={handleCurrency}></div>
                <div className="currencyMenu__signpop bg-white rounded-4">
                    <div className="d-flex items-center justify-between px-30 py-20 sm:px-15 border-bottom-light">
                        {/* End Title */}
                        <div />

                        <button className="pointer" onClick={handleCurrency}>
                            <i className="icon-close" />
                        </button>
                        {/* End colse button */}
                    </div>
                    {/* End flex wrapper */}
                    <div
                        className="text-20 fw-500 lh-15 px-30  py-30 sm:px-15 sm:py-15"
                        style={{
                            textAlign: "center",
                        }}
                    >
                        To continue Booking, please sign in to your account
                    </div>
                    <div
                        className="px-30  py-30 sm:px-15 sm:py-15"
                        style={{
                            textAlign: "center",
                        }}
                    >

                        <button
                            className="btn bg-dark-3 text-white"
                            onClick={() => {
                                // router.push("/sign-in/sign-in");
                                sessionStorage.setItem("isSig", true);
                                setClick(false);
                            }}
                        >
                            Sign In
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export async function getServerSideProps(context) {
    const rawPath = context.resolvedUrl;
    let path = rawPath.split("?")[0];
    if (path.length > 1 && path.endsWith("/")) {
        path = path.slice(0, -1);
    }
    const metaHome = await fetchSeoByPage(path);
    return {
        props: { meta: metaHome }
    };
}